import { render, staticRenderFns } from "./organization-file-approval-survey-view.vue?vue&type=template&id=2cac919d&scoped=true"
import script from "./organization-file-approval-survey-view.vue?vue&type=script&lang=js"
export * from "./organization-file-approval-survey-view.vue?vue&type=script&lang=js"
import style0 from "./organization-file-approval-survey-view.vue?vue&type=style&index=0&id=2cac919d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cac919d",
  null
  
)

export default component.exports